'use strict';
module.exports = function(id) {
  var el, error, text;
  if (id == null) {
    id = 'domConfig';
  }
  el = document.getElementById(id);
  if (!el) {
    return {};
  }
  text = (el.textContent || el.innerText).trim();
  try {
    return JSON.parse(text);
  } catch (error1) {
    error = error1;
    error.message += 'Attempted to parse:' + text;
    throw error;
  }
};

